$ = jQuery;

/*
* Evento de clique no menu de subcategorias do header
*/
$('.jc-menu-subcategory a').on('click', function() {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Header',
    'eventAction': 'Clique - Menu - Subcategory',
    'eventLabel':  $(this).text()
  });

  gtag('event', 'Header', {
    'eventAction': 'Clique - Menu - Subcategory',
    'eventLabel':  $(this).text()
  });
});

/*
* Evento de clique no menu de breadcrumb do header
*/
$('.jc-breadcrumb-menu a').on('click', function() {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Header',
    'eventAction': 'Clique - Menu - Breadcrumb',
    'eventLabel':  $(this).text()
  });

  gtag('event', 'Header', {
    'eventAction': 'Clique - Menu - Breadcrumb',
    'eventLabel':  $(this).text()
  });
});

/*
* Evento de clique no author
*/
$('.jc-author-link').on('click', function() {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post',
    'eventAction': 'Clique - Author',
    'eventLabel':  $(this).text()
  });

  gtag('event', 'Post', {
    'eventAction': 'Clique - Author',
    'eventLabel':  $(this).text()
  });
});